// extracted by mini-css-extract-plugin
export default {"loginSlide":"slider-content_loginSlide__k-axH","slideName":"slider-content_slideName__YYMAN","slideDescription":"slider-content_slideDescription__p38OL"};